import { SvgIcon, SvgIconProps } from '@mui/material'
import { NovaColours, useAppContext } from '@novafuturltd/core'

export const SectionsIcon = (props: SvgIconProps) => {
  const { mode } = useAppContext()
  const defaultFill = NovaColours.N040[mode]

  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 13H3V3H11V13ZM11 21H3V15H11V21ZM13 21H21V11H13V21ZM13 9V3H21V9H13Z"
        fill={defaultFill}
      />
    </SvgIcon>
  )
}

export default SectionsIcon
